import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { PushPipe } from '@ngrx/component';
import {
    WdxButtonModule,
    WdxButtonStyle,
} from '@wdx/shared/components/wdx-button';
import { WdxIconModule } from '@wdx/shared/components/wdx-icon';
import { WdxIconContainerModule } from '@wdx/shared/components/wdx-icon-container';
import { WdxInfoCardModule } from '@wdx/shared/components/wdx-info-card';
import { FileSizePipe } from '@wdx/shared/utils';
import { NgxDropzoneChangeEvent, NgxDropzoneModule } from 'ngx-dropzone';

import { ImportEventType } from '@wdx/kamino/api-service';
import { ICONS } from '@wdx/kamino/utils/constants';
import { WdxIsLoadingModule } from '@wdx/shared/components/wdx-is-loading';
import { KaminoFileUploaderService } from './file-uploader.service';

@Component({
    selector: 'kamino-file-uploader',
    imports: [
        NgxDropzoneModule,
        WdxInfoCardModule,
        WdxIconModule,
        WdxButtonModule,
        WdxIconContainerModule,
        FileSizePipe,
        PushPipe,
        NgbProgressbarModule,
        WdxIsLoadingModule,
    ],
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
})
export class KaminoFileUploaderComponent {
    public fileUploaderService = inject(KaminoFileUploaderService);

    @Output() fileEvent = new EventEmitter();
    @Output() overwriteLocalChanges = new EventEmitter<boolean>();

    @Input() path!: string;
    @Input() acceptedFileTypes!: string;

    rejectedFiles = false;
    acceptedFiles!: File[];

    readonly WDX_BUTTON_STYLE = WdxButtonStyle;
    readonly ICONS = ICONS;

    onAddFiles(event: NgxDropzoneChangeEvent) {
        this.resetCheckboxState();
        this.rejectedFiles = Boolean(event.rejectedFiles.length);
        this.acceptedFiles = event.addedFiles;

        if (event.rejectedFiles.length) {
            return;
        }

        try {
            this.fileUploaderService.addFiles(this.acceptedFiles);
        } catch (error) {
            console.error(error);
        }
    }

    onFileEvent(event: ImportEventType): void {
        this.fileEvent.emit(event);
    }

    onCheckboxChange(event: Event) {
        const checked = (event.target as HTMLInputElement).checked;
        this.overwriteLocalChanges.emit(checked);
    }

    resetCheckboxState(): void {
        this.overwriteLocalChanges.emit(false);
    }
}
